import {Component, Injector, OnDestroy, OnInit} from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ChangePasswordInfo } from '../../models/account';
import { AccountService } from '../../services/account.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as fromStore from '../../store';
import {WindowService} from '../../services/window.service';
import {Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {marker as TRANSLATE} from '@biesbjerg/ngx-translate-extract-marker';


@Component({
  standalone: false,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  ChangePasswordInfo: ChangePasswordInfo = {
    Account: '',
    Package: '',
    Password: '',
    NewPassword: ''
  };
  PasswordConfirm: string;
  logoPath: string;
  hostName: string;
  private componentDestroyed = new Subject();
  constructor(
    private store: Store<fromStore.State>,
    private router: Router,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private apiService: AccountService,
    private windowService: WindowService,
    private translateService: TranslateService) {
    this.hostName = this.windowService.getHostName();
    this.store.select(fromStore.getRegions).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.length > 0) {
        const region = this.windowService.getLogoRegion(res);
        if (typeof region !== 'undefined' && region !== null) {
          this.logoPath = region.Note;
        }
        // const logoPath = res.find(i =>　i.Region.toLowerCase() === this.hostName.toLowerCase()).Note;
        // if (typeof logoPath !== 'undefined' && logoPath !== null) {
        //   this.logoPath = logoPath;
        // }
      }
    });
  }

  ngOnInit() {
    this.ngxService.start();
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-login');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    this.route.queryParams.subscribe((value) => {
      this.ChangePasswordInfo.Password = value['hashStr'];
      const hashStr = value['hashStr'].split('||');
      this.ChangePasswordInfo.Account = hashStr[1];
    });
    this.ngxService.stop();
  }

  resetPassword(e) {
    this.ngxService.start();
    if (e.valid && e.value.NewPassword === e.value.PasswordConfirm) {
      this.apiService.ChangeResettingPassword(this.ChangePasswordInfo).subscribe(res => {
        alert(res.Flag ? this.translateService.instant(TRANSLATE('Update successful.')) :
          this.translateService.instant(TRANSLATE('Update Failed.')));
        this.router.navigate(['/login']);
      });
    } else {
      this.ngxService.stop();
    }
  }
  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
